import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Expertise } from "@/components/Expertise";
import { Portfolio } from "@/components/Portfolio";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Admin } from "@/components/Admin";
import { GoogleLogin } from "@/components/GoogleLogin";
import { AuthCallback } from "@/components/AuthCallback";
import { ServicesPage } from "@/components/ServicesPage";
import { PaymentSuccess } from "@/components/PaymentSuccess";
import { PaymentCancel } from "@/components/PaymentCancel";
import { SubscriptionSuccess } from "@/components/SubscriptionSuccess";
import { Toaster } from "@/components/ui/sonner";
import ConfiguratorPage from "@/components/ConfiguratorPage";
import ClientLogin from "@/components/ClientLogin";
import ClientSpace from "@/components/ClientSpace";
import SharePage from "@/components/SharePage";
import ContactPage from "@/components/ContactPage";
import LegalPage from "@/components/LegalPage";
import ReviewsPage from "@/components/ReviewsPage";
import { PageTracker } from "@/components/PageTracker";
import { ConfiguratorTeaser } from "@/components/ConfiguratorTeaser";

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check URL fragment for session_id SYNCHRONOUSLY during render
  // This prevents race conditions by processing session_id BEFORE checking existing session
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
    <PageTracker />
    <Routes>
      {/* Public routes */}
      <Route path="/" element={
        <>
          <Header />
          <Hero />
          <About />
          <Expertise />
          <Portfolio />
          <ConfiguratorTeaser />
          <Contact />
          <Footer />
        </>
      } />
      
      <Route path="/configurateur" element={
        <>
          <Header />
          <ConfiguratorPage />
          <Footer />
        </>
      } />

      {/* Services & Payment routes */}
      <Route path="/services" element={
        <>
          <Header />
          <ServicesPage />
          <Footer />
        </>
      } />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/subscriptions/success" element={<SubscriptionSuccess />} />
      <Route path="/subscriptions/cancel" element={<PaymentCancel />} />
      
      <Route path="/contact" element={
        <>
          <Header />
          <ContactPage />
          <Footer />
        </>
      } />
      <Route path="/mentions-legales" element={
        <>
          <Header />
          <LegalPage />
          <Footer />
        </>
      } />
      <Route path="/avis-clients" element={
        <>
          <Header />
          <ReviewsPage />
          <Footer />
        </>
      } />
      <Route path="/connexion" element={<ClientLogin />} />
      <Route path="/partage/:id" element={
        <>
          <Header />
          <SharePage />
          <Footer />
        </>
      } />
      <Route path="/mon-espace" element={
        <>
          <Header />
          <ClientSpace />
          <Footer />
        </>
      } />

      {/* Auth routes */}
      <Route path="/login" element={<GoogleLogin />} />
      <Route path="/dashboard" element={<Admin />} />
      <Route path="/admin" element={<Navigate to="/dashboard" replace />} />
      
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <AppRouter />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
